module.exports = __webpack_public_path__ + "static/media/gen_img22.55f99d75.png";